import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonDate'
})
export class JsonDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const original: string = value;
    // replace anything but numbers by spaces
    value = value.replace(/\D/g, ' ');
    // trim any hanging white space
    value = value.replace(/\s+$/, '');
    // split on space
    let dtcomps = [];
    dtcomps = value.split(' ');
    // not all ISO 8601 dates can convert, as is
    // unless month and date specified, invalid
    if (dtcomps.length < 3) {
      return null;
    }
    // if time not provided, set to zero
    if (dtcomps.length < 4) {
      dtcomps[3] = 0;
      dtcomps[4] = 0;
      dtcomps[5] = 0;
    }

    let tzHour = 0;
    let tzMinute = 0;
    let tzMultiplier = 1;

    if (dtcomps.length === 9) {
      tzHour = dtcomps[7];
      tzMinute = dtcomps[8];
      if (original.lastIndexOf('+') > -1) {
        tzMultiplier = -1;
      }
    }

    // modify month between 1 based ISO 8601 and zero based Date
    dtcomps[1]--;
    const convdt = new Date(Date.UTC(dtcomps[0], dtcomps[1], dtcomps[2], dtcomps[3], dtcomps[4], dtcomps[5]));
    convdt.setTime(convdt.getTime() + (tzHour * 60 * 60 * 1000 + tzMinute * 60 * 1000) * tzMultiplier);
    return convdt;
  }

}
